import React, { useState, useEffect, useRef } from 'react';
import '../css/header.css';
import hiverooms from '../assets/images/main-logo.png';
import ph from '../assets/icons/icon_ph.png';
import { Link } from 'react-router-dom';
import useOnClickOutside from '../hooks/useOnClickOutside';

function Header({ setShowLoginModal }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [isLanguageModalOpen, setIsLanguageModalOpen] = useState(false);
  const menuRef = useRef(null);

    // New state for scroll effect
  const [scrolled, setScrolled] = useState(false);

  // Close menu when clicking outside
  useOnClickOutside(menuRef, () => setMenuOpen(false));

  // Scroll listener added here
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Cleanup on unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const toggleMenu = () => {
    setMenuOpen(prev => !prev);
  };


  return (
    <header className={`main-header ${scrolled ? 'scrolled' : ''}`}>
      <div className="header-top">
        <div className="header-left">
            <button className={`hamburger-btn ${menuOpen ? 'open' : ''}`} onClick={toggleMenu} aria-label="Toggle menu">
                <span className={`bar ${menuOpen ? 'open' : ''}`}></span>
                <span className={`bar ${menuOpen ? 'open' : ''}`}></span>
                <span className={`bar ${menuOpen ? 'open' : ''}`}></span>
            </button>
            <div className="top-logo">
               <a href="/"><img src={hiverooms} alt="HiveRooms" /></a>
            </div>
            {/* <div className="search-container">
                <input
                    type="text"
                    placeholder="Destination, attraction, hotel, etc.."
                    value={searchTerm}btn-login
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="search-input"
                />
                <button className="search-button">
                    <i className="fas fa-search"></i>
                </button>
            </div> */}
        </div>
        <div className="header-right">

        {/* Language flag button */}
        {/* <div className="header-flag-selector">
          <button onClick={() => setIsLanguageModalOpen(true)} className="flag-btn">
            <img src="https://flagcdn.com/ph.svg" alt="PH Flag" />
          </button>
        </div> */}

        {/* Language Modal */}
          {isLanguageModalOpen && (
            <div className="modal" onClick={() => setIsLanguageModalOpen(false)}>
              <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <span className="close" onClick={() => setIsLanguageModalOpen(false)}>
                  &times;
                </span>
                <h2>Select your language</h2>

                <h4>Suggested languages</h4>
                <div className="language-list">
                  <div className="language-option selected">
                    <img src="https://flagcdn.com/ph.svg" alt="PH Flag" />
                    English
                    <span className="checkmark">&#10003;</span>
                  </div>
                </div>

                <h4>All languages</h4>
                <div className="language-list">
                  <div className="language-option">
                    <img src="https://flagcdn.com/us.svg" alt="US Flag" /> English
                  </div>
                  <div className="language-option">
                    <img src="https://flagcdn.com/kr.svg" alt="KR Flag" /> 한국어
                  </div>
                  <div className="language-option">
                    <img src="https://flagcdn.com/jp.svg" alt="JP Flag" /> 日本語
                  </div>
                  <div className="language-option">
                    <img src="https://flagcdn.com/cn.svg" alt="CN Flag" /> 简体中文
                  </div>
                  <div className="language-option">
                    <img src="https://flagcdn.com/tw.svg" alt="TW Flag" /> 繁體中文（台灣）
                  </div>
                  <div className="language-option">
                    <img src="https://flagcdn.com/de.svg" alt="DE Flag" /> Deutsch
                  </div>
                </div>
              </div>
            </div>
          )}

            <ul>
                <li><a href="tel:+639171234567" className="navlink"><i className="fa-solid fa-phone-volume"></i>Stay in touch</a></li>
            </ul>
            {/* <button className="btn-login" onClick={() => setShowLoginModal(true)}>
                <i className="fas fa-user-circle"></i>Edit Booking
            </button> */}
        </div>
      </div>

    {/* Navigation menu, show/hide based on menuOpen */}
    <div ref={menuRef}>
      <nav className={`nav-menu ${menuOpen ? 'active' : ''}`}>
        <ul>
          <li><a href="/">Home</a></li>
          <li><Link to="/about-us" onClick={() => setMenuOpen(false)}>About Us</Link></li>
          <li><Link to="/partner-with-us" onClick={() => setMenuOpen(false)}>Partner with us</Link></li>
          <li><Link to="/news-room" onClick={() => setMenuOpen(false)}>Newsroom</Link></li>
          <li><Link to="/our-commitment" onClick={() => setMenuOpen(false)}>Our Commitment</Link></li>
        </ul>
      </nav>
    </div>
    </header>
  );
}

export default Header;